module.exports = __webpack_public_path__ + "media/images/android-915f50d8.png";